export function loadStyle(href: string): Promise<void> {
    return new Promise((resolve, reject) => {
        const bundleStyle = document.createElement('link');

        bundleStyle.setAttribute('rel', 'stylesheet');
        bundleStyle.setAttribute('href', href);

        bundleStyle.addEventListener('load', () => {
            resolve();
        });
        bundleStyle.addEventListener('error', reject);

        document.head.appendChild(bundleStyle);
    });
}

export function loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
        const bundleScript = document.createElement('script');

        bundleScript.setAttribute('src', src);

        bundleScript.addEventListener('load', () => {
            resolve();
        });
        bundleScript.addEventListener('error', reject);

        document.head.appendChild(bundleScript);
    });
}
